<template>
    <div class="point-card" :class="{ 'point-disabled': !nowShow }">
        <div class="point-card-title">
            <el-input v-model="searchInput" class="search-text" placeholder="请输入关键字" @keyup.enter="searchObject" />
            <div class="search-btn icon-tools-search" title="搜索" @click="searchObject()"></div>
        </div>
        <div class="point-card-body">

            <div class="point-card-features">
                <ul class="point-legend">
                    <li class="features-panel-title" v-for="(val, key, index) in objectMap" :key="index">
                        <input type="checkbox" :id="key" class="toggle-checkbox">
                        <label :for="key" class="category-toggle-btn icon-icomoon-Triangle-1"></label>
                        <span class="category-info">
                            <div title="修改样式" class="category_style" :class="{ 'category_style_point': true }">
                            </div>
                            <div class="category-name">{{ val.title }}</div>
                            <div class="category-count">（<span>{{ val.objects.length }}</span>）</div>
                        </span>
                        <div class="features-panel-list">
                            <ol class="category-child-ul">
                                <template v-for="(item, index) in filteredObjects(key)" :key="index">
                                    <li class="category-children-li" @click="flyToObject(item)">
                                        <span class="category-children-li-text" :title="item.title">{{ item.item.title
                                        }}</span>
                                    </li>
                                </template>
                            </ol>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { addDescription, getDescriptionCode, updateLayer, delLayer, getConfigList } from '@/api/Common'
import { useMapStore } from '@/stores/mapStore';
import { MapUtils } from '@/utils/mapUtils';


import { h, createApp } from 'vue';


import DataTablePanel from './DataTablePanel.vue';


// 引入 InfoPanel 组件
import InfoPanel from './InfoPanel.vue';


import { ElMessage, ElMessageBox } from 'element-plus'

export default {
    name: 'PointCard',
    components: {
        InfoPanel,
        DataTablePanel
    },
    data() {
        return {

            // descriptionList: [],
            layer: null,
            mapStore: null,
            objectMap: {},
            objectKeyMap: {},

            nowShow: false,
            searchInput: "",
            searchText: "",
            layerName: "点标注列表"
        }
    },
    props: {

        layerShow: {
            type: Boolean, // 假设 item 是对象类型，根据实际情况调整
            required: false // 表示该参数是必需的 
        }
    },
    computed: {
        // 计算属性，根据搜索关键词过滤对象列表
        filteredObjects() {
            return (key) => {
                if (!this.searchText) {
                    return this.objectMap[key].objects;
                }
                return this.objectMap[key].objects.filter(item =>
                    item.item.title.includes(this.searchText)
                );
            };
        }
    },
    mounted() {

        this.mapStore = useMapStore();
        let that = this;
        this.mapStore.loadCodeList(function () {
            that.mapStore.setSelectLayerCard(that);
            // this.layer = this.mapStore.createLayer();
            that.layer = that.mapStore.createLayer();

            let userJurisdiction = that.mapStore.getUseJurisdiction();

            userJurisdiction.forEach(item => {

                that.getDescriptionCode(item);
            });



        });



        // getConfigList().then(res => {
        //     console.log(res);
        //     if (res.code == 200) {

        //     }
        // })



    },
    watch: {

        layerShow: {
            immediate: true, // 初始化时立即执行一次
            handler(newVal) {
                this.nowShow = newVal;
            }
        },
        nowShow: {
            immediate: true, // 初始化时立即执行一次
            handler(newVal) {
                this.toggleLayerVisibility();
            }
        }
    },
    // 在组件销毁前执行移除操作
    beforeDestroy() {

    },
    methods: {
        findItemById(list, targetId) {
            for (const item of list) {
                if (item.id === targetId) {
                    return item;
                }
                if (item.children) {
                    const result = this.findItemById(item.children, targetId);
                    if (result) {
                        return result;
                    }
                }
            }
        },
        searchObject() {
            this.searchText = this.searchInput;

        },
        openDataTable() {
            this.$refs.dataTable.open();
        },
        removeObjects(code) {
            this.objectKeyMap[code] = [];
            if (!this.objectMap[code]) {
                return;
            }
            
            let objectList = this.objectMap[code].objects;
            objectList.forEach(obj => {
                if (obj) {
                    
                    this.layer.removeLayer(obj);
                }
            });
            this.objectMap[code].objects = []; // 清空数组
        },
        addDescription(item, object, city) {
            this.refreshDescription(item.code);
        },
        refreshDescription(code) {
            this.removeObjects(code);
            this.getDescriptionCode({
                atlasCodeId: code
            });

        },
        // addDescription(item, object, city) {
        //     if (!this.objectMap[item.code]) {
        //         this.objectMap[item.code] = {};
        //         this.objectMap[item.code].title = city;
        //         this.objectMap[item.code].objects = [];
        //     }
        //     object.item = item;
        //     // 创建一个临时的 DOM 元素来挂载 InfoPanel 组件
        //     const container = document.createElement('div');
        //     // 设置 popup 容器的宽度
        //     container.style.width = '300px';
        //     // 使用 h 函数创建虚拟 DOM 节点
        //     const vnode = h(InfoPanel, {
        //         object: object,
        //         layer: this,
        //     });
        //     // 使用 createApp 创建应用实例并挂载
        //     const app = createApp({
        //         render: () => vnode
        //     });
        //     app.mount(container);

        //     // 创建 popup 并绑定到对象上
        //     let popup = object.bindPopup(container);
        //     object.on('click', function () {
        //         this.mapStore.endEditObject();
        //         popup.openPopup();
        //     });
        //     this.objectMap[item.code].objects.push(object);
        // },

        toggleLayerVisibility() {
            if (this.layer && this.mapStore && this.mapStore.map) {
                if (this.nowShow) {
                    if (!this.mapStore.map.hasLayer(this.layer)) {
                        this.mapStore.map.addLayer(this.layer);
                    }
                } else {
                    if (this.mapStore.map.hasLayer(this.layer)) {
                        this.mapStore.map.removeLayer(this.layer);
                    }
                }
            }
        },
        getDescriptionCode(jurisdiction) {


            let that = this;
            getDescriptionCode({ "code": jurisdiction.atlasCodeId }).then(res => {
                if (res.code == 200) {
                    //that.descriptionList = res.rows;
                    that.createObjectsFromData(res.rows);
                }
            })
        },
        // getDescriptionList() { },
        createObjectsFromData(descriptionList) {

            if (this.layer) {
                let that = this;
                // 定义自定义图标和阴影图标
                // const customIcon = L.icon({
                //     iconUrl: markerIcon, // 替换为你的图标路径
                //     iconSize: [25, 41], // 图标大小
                //     iconAnchor: [12.5, 41], // 图标锚点
                //     popupAnchor: [-3, -76], // 弹出窗口锚点
                //     shadowUrl: markerShadow, // 替换为你的阴影图标路径
                //     shadowSize: [41, 41], // 阴影图标大小
                //     shadowAnchor: [12.5, 41] // 阴影图标锚点
                // });


                // console.log(descriptionList);
                //objectMap
                // if (!this.objectMap[jurisdiction.atlasCodeId]) {
                //     this.objectMap[jurisdiction.atlasCodeId] = {};
                //     this.objectMap[jurisdiction.atlasCodeId].title = jurisdiction.city;
                //     this.objectMap[jurisdiction.atlasCodeId].objects = [];
                // }
                descriptionList.forEach(item => {

                    if (that.objectKeyMap[item.code] && that.objectKeyMap[item.code].indexOf(item.id) != -1) {
                        return;
                    }

                    let points = [];
                    let position = null;
                    let object = null;


                    const iconSizes = {
                        '0': {
                            size: [28, 36],
                            class: 'small-svg',
                        }, // 小
                        '1': {
                            size: [35, 45],
                            class: 'medium-font',
                        }, // 中
                        '2': {
                            size: [42, 54],
                            class: 'large-font',
                        }  // 大
                    };
                    const iconConfig = iconSizes[item.sizeState] || iconSizes['1'];
                    const size = iconConfig.size;
                    const className = iconConfig.class;


                    const customIcon = L.AwesomeMarkers.icon({
                        icon: 'bi-building-fill',
                        markerColor: 'red',
                        popupAnchor: [0, -66], // 弹出窗口锚点
                        className: 'awesome-marker ' + className,
                        iconSize: size, // 设置图标大小
                        // extraClasses:'large-font'
                        // iconAnchor: iconAnchor,
                        // popupAnchor: popupAnchor
                    });





                    let locations = item.locations;
                    let type = item.type;

                    switch (type) {
                        case '0':
                            position = [item.latitude, item.longitude];
                            //position = item.description.split(",");
                            if (position.length == 2) {
                                // 创建点标记
                                object = L.marker(position, {
                                    icon: customIcon
                                }).addTo(this.layer);
                            }
                            break;
                        case '1':
                            points = locations;
                            if (points.length > 2) {
                                position = [];
                                for (let i = 0; i < points.length; i++) {
                                    position.push([points[i].latitude, points[i].longitude]);
                                }
                                // 创建线
                                object = L.polyline(position, { color: 'blue' }).addTo(this.layer);
                            }
                            break;
                        case '2':
                            points = locations;
                            if (points.length > 2) {
                                position = [];
                                position.push([]);
                                for (let i = 0; i < points.length; i++) {
                                    position[0].push([points[i].latitude, points[i].longitude]);
                                }
                                // 创建面
                                object = L.polygon(position, { color: 'green' }).addTo(this.layer);
                            }
                            break;
                        default:
                            position = [item.latitude, item.longitude];
                            //position = item.description.split(",");
                            if (position.length == 2) {

                                // 创建点标记
                                object = L.marker(position, {
                                    icon: customIcon
                                }).addTo(this.layer);

                            }
                            break;
                    }
                    if (object) {
                        object.item = item;
                        // 创建一个临时的 DOM 元素来挂载 InfoPanel 组件
                        const container = document.createElement('div');
                        // 设置 popup 容器的宽度
                        container.style.width = '300px';
                        // 使用 h 函数创建虚拟 DOM 节点
                        const vnode = h(InfoPanel, {
                            object: object,
                            layer: this,
                        });
                        // 使用 createApp 创建应用实例并挂载
                        const app = createApp({
                            render: () => vnode
                        });
                        app.mount(container);

                        // 创建 popup 并绑定到对象上
                        let popup = object.bindPopup(container);
                        object.on('click', function () {
                            that.mapStore.endEditObject();
                            popup.openPopup();
                        });
                        if(!that.objectKeyMap[item.code])
                        {
                            that.objectKeyMap[item.code] = [];
                        }
                        that.objectKeyMap[item.code].push(item.id);
                        if (!that.objectMap[item.code]) {
                            that.objectMap[item.code] = {};
                            let cityInfo = that.findItemById(that.mapStore.codeList, item.code);

                            let cityName = "中国";
                            if (cityInfo && cityInfo.atlasName) {
                                cityName = cityInfo.atlasName;
                            }
                            that.objectMap[item.code].title = cityName;
                            that.objectMap[item.code].objects = [];
                        }

                        that.objectMap[item.code].objects.push(object);
                    }
                });

            }
        },

        // ... 已有代码 ...
        flyToObject(item) {
            const targetObject = item;
            if (targetObject) {

                let targetLatLng;
                if (targetObject instanceof L.Marker || targetObject instanceof L.Circle || targetObject instanceof L.CircleMarker) {
                    // 标记、圆形和圆形标记使用 getLatLng 方法
                    targetLatLng = targetObject.getLatLng();
                } else if (targetObject instanceof L.Polygon || targetObject instanceof L.Polyline) {
                    // 多边形和折线取第一个点
                    const latLngs = targetObject.getLatLngs();
                    targetLatLng = Array.isArray(latLngs[0]) ? latLngs[0][0] : latLngs[0];
                }
                if (targetObject.getPopup) {
                    targetObject.openPopup();
                }
                if (targetLatLng) {
                    // 使用地图实例的 flyTo 方法飞到目标位置
                    this.mapStore.map.flyTo([targetLatLng.lat, targetLatLng.lng]); // 15 为缩放级别，可按需调整
                }
            }
        }
    }
}

</script>

<style scoped>
.point-disabled {
    opacity: 0.4;
}

/* 隐藏 checkbox */
.toggle-checkbox {
    display: none;
}

.search-text {

    width: calc(100% - 30px);
    height: 30px;

    border: 1px solid #eee;

}

.search-btn {
    float: right;
    margin-top: 3px;
    cursor: pointer;
}

/* 默认隐藏 features-panel-list */
.features-panel-list {
    display: none;
    width: calc(100% - 20px);

    overflow-y: auto;

}

/* 当 checkbox 被选中时，显示 features-panel-list */
.toggle-checkbox:checked~.features-panel-list {
    display: block;
}

.select-point {
    border: 2px solid #0095ff !important;
}

.category-toggle-btn {
    transform: rotate(0deg);
}

.toggle-checkbox:checked~.category-toggle-btn {
    transform: rotate(90deg);
}

.category-children-li {
    height: 22px;
    line-height: 22px;
    margin-top: 6px;
    margin-bottom: 6px;
    font-size: 12px;
    cursor: pointer;
    padding-left: 30px;
}

.category-children-li:hover {
    background: #d4eefe;
}

.point-legend {
    overflow: visible;
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 32px;
    /* 计算高度，100vh 表示视口高度，减去标题高度和上下内边距 */
    height: calc(100vh - 100px);
    box-sizing: border-box;
    overflow-y: auto;
}

.features-panel-title {
    position: relative;
    clear: both;
    height: auto;
    cursor: pointer;
    margin-top: 8px;
    list-style: none;
}


.point-card {

    height: 100%;
    width: 282px;
    position: relative;
    background-color: #fff;
    border: 2px solid transparent;

    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);

}

.point-card-title {
    padding-left: 10px;
    padding-right: 10px;
    height: 32px;
    line-height: 32px;
    background-color: #f5f7fa;

}

.point-visible {
    margin-top: 8px;
    color: #0095ff;
    float: left !important;
    cursor: pointer;
    font-size: 12px;
}

.point-title-text {
    width: 200px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    float: left;
    margin-left: 8px;
    color: #576d8b;
    display: block;
}

.point-zoom {
    float: right;
    margin-top: 8px;
    color: #576d8b;
    cursor: pointer;
    margin-left: 6px;
    font-size: 12px;
    display: none;
}

.point-title-edit {
    float: left;
    width: 200px;
    margin-left: 12px;
    position: relative;
}

.point-title-input {
    height: 24px;
    margin-top: 4px;
    padding-right: 24px;
    display: block;
    width: 100%;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.42857143;
    color: #555555;
    background-color: #ffffff;
    background-image: none;
    border: 1px solid #cccccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    -webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
    -o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
    transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
}

.point-title-edit-save {
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
}

.point-title-input:focus {
    border-color: #66afe9;
    outline: 0;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
}

.point-title-trigger {
    float: right;
    margin-top: 8px;
    color: #576d8b;
    cursor: pointer;
    display: none;
}

.point-card-title:hover .point-zoom {
    display: inline-block !important;
}

.point-card-title:hover .point-title-trigger {
    display: inline-block !important;
}

.point-card-body {
    padding-bottom: 6px;
}

.point-card-tools {
    height: 32px;
    line-height: 24px;
    margin-left: 28px;
    border-bottom: 1px solid #c9d3e0;
    overflow: hidden;
}

.point-style {
    padding: 0;
    margin-top: 6px;
    color: #0095ff;
    font-size: 12px;
    cursor: pointer;
    user-select: none;
    margin-right: 10px;
    width: 33.33333333%;
    float: left;

}

.point-style .text {
    vertical-align: top;
}

.point-card-body .text {
    font-size: 12px;
    color: #576d8b;
    width: 31%;
    margin-left: 2px;
}

.data-list {
    padding: 0;
    color: #0095ff;
    font-size: 12px;
    cursor: pointer;
    margin-top: 6px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 64px;
    margin-right: 18px;
    float: left;
    text-align: right;
}

.more-list {
    margin-top: 6px;
    padding-right: 10px !important;
    width: 74px;
    float: right;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    padding: 0;
    margin-top: 6px;
    color: #0095ff;
    font-size: 12px;
    cursor: pointer;
    text-align: right;
}


.category-toggle-btn {
    position: absolute;
    cursor: pointer;
    left: -18px;
    top: 5px;
    transform: scale(0.7);
    -webkit-transform: scale(0.7);
    -moz-transform: scale(0.7);
    -ms-transform: scale(0.7);
    -o-transform: scale(0.7);
}

.category_style {
    margin-top: 3px;
    height: 14px;
    width: 14px;
    border: 1px solid rgba(255, 0, 0, 0.8);
    background-color: rgba(255, 183, 59, 0.8);

    float: left;
}

.category_style_point {
    border-radius: 50%;
}

.category-info {
    display: inline-block;
    width: 184px;
    line-height: 22px
}

.category-info:hover {
    background: #87c4eb;
}

.category-name {
    display: inline-block;
    padding-left: 10px;
    padding-right: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    float: left;
    font-size: 12px;
    margin-left: 8px;
}

.category-count {
    float: left !important;
}
</style>